import base from "../baseurl";
import token from "../getTk";

const showAll = async () => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("sport-events/showall", {
      json: {},
      timeout: false,
    })
    .json();
  console.log("la lista principal", Create);
  return Create;
};

export default showAll;
